const discountsEn = {
  "disc.title": "Discounts",
  "disc.create": "Create discount",
  "disc.select_type": "Select discount type",
  "disc.empty_title": "Manage discounts and promotions",
  "disc.empty_body": "Create discount codes and automatic discounts that apply at checkout. You can also combine them.",
  "disc.search": "Search by title or code",
  "disc.none_match": "No discounts match these filters.",
  "disc.filter.method": "Method",
  "disc.filter.type": "Type",
  "disc.col.title": "Title",
  "disc.col.status": "Status",
  "disc.col.method": "Method",
  "disc.col.type": "Type",
  "disc.col.combinations": "Combinations",
  "disc.col.used": "Used",
  "disc.more_codes": "+{n} codes",
  "disc.status.active": "Active",
  "disc.status.scheduled": "Scheduled",
  "disc.status.expired": "Expired",
  "disc.method.code": "Code",
  "disc.method.automatic": "Automatic",
  "disc.method_long.code": "Discount code",
  "disc.method_long.automatic": "Automatic discount",
  "disc.type.product": "Amount off products",
  "disc.type.order": "Amount off order",
  "disc.type.bxgy": "Buy X get Y",
  "disc.type.shipping": "Free shipping",
  "disc.type_hint.product": "Discount specific products or collections of products.",
  "disc.type_hint.order": "Discount the total order amount.",
  "disc.type_hint.bxgy": "Discount products based on a customer's purchase.",
  "disc.type_hint.shipping": "Offer free shipping on an order.",
  "disc.method": "Method",
  "disc.code": "Discount code",
  "disc.code_hint": "Customers must enter this code at checkout.",
  "disc.generate": "Generate",
  "disc.title_field": "Title",
  "disc.title_hint": "Customers will see this in their cart and at checkout.",
  "disc.n_codes": "{n} codes",
  "disc.manage_codes": "Manage codes",
  "disc.add_more_codes": "Add more codes or generate them in bulk",
  "disc.value": "Discount value",
  "disc.percentage": "Percentage",
  "disc.fixed": "Fixed amount",
  "disc.free": "Free",
  "disc.applies_to": "Applies to",
  "disc.items.all": "All products",
  "disc.items.collections": "Specific collections",
  "disc.items.products": "Specific products",
  "disc.once_per_order": "Only apply the discount once per order",
  "disc.exclude_sale": "Exclude items already on sale",
  "disc.buys": "Customer buys",
  "disc.buy_quantity": "Minimum quantity of items",
  "disc.buy_amount": "Minimum purchase amount",
  "disc.quantity": "Quantity",
  "disc.amount": "Amount",
  "disc.any_items_from": "Any items from",
  "disc.gets": "Customer gets",
  "disc.gets_hint": "Customers must add the quantity of items specified below to their cart.",
  "disc.at_value": "At a discounted value",
  "disc.max_uses_per_order": "Set a maximum number of uses per order",
  "disc.countries": "Countries",
  "disc.all_countries": "All countries",
  "disc.selected_countries": "Selected countries",
  "disc.exclude_rates": "Exclude shipping rates over a certain amount",
  "disc.minimum": "Minimum purchase requirements",
  "disc.min.none": "No minimum requirements",
  "disc.min.amount": "Minimum purchase amount",
  "disc.min.quantity": "Minimum quantity of items",
  "disc.min.applies_selected": "Applies only to the selected products or collections.",
  "disc.eligibility": "Customer eligibility",
  "disc.elig.all": "All customers",
  "disc.elig.segments": "Specific customer segments",
  "disc.elig.customers": "Specific customers",
  "disc.limits": "Maximum discount uses",
  "disc.limit_total": "Limit number of times this discount can be used in total",
  "disc.limit_once": "Limit to one use per customer",
  "disc.combinations": "Combinations",
  "disc.combinations_hint": "This discount can be combined with:",
  "disc.combine.product": "Product discounts",
  "disc.combine.order": "Order discounts",
  "disc.combine.shipping": "Shipping discounts",
  "disc.dates": "Active dates",
  "disc.start_date": "Start date",
  "disc.start_time": "Start time ({tz})",
  "disc.set_end": "Set end date",
  "disc.end_date": "End date",
  "disc.end_time": "End time ({tz})",
  "disc.summary": "Summary",
  "disc.no_code": "No discount code yet",
  "disc.no_title": "No title yet",
  "disc.performance": "Performance",
  "disc.used": "Used {n} times",
  "disc.duplicate": "Duplicate",
  "disc.activate": "Activate",
  "disc.deactivate": "Deactivate",
  "disc.activated": "Discount activated.",
  "disc.deactivated": "Discount deactivated.",
  "disc.delete": "Delete discount",
  "disc.delete_title": "Delete this discount?",
  "disc.delete_body": "Customers can no longer use it. This can't be undone.",
  "disc.codes": "Discount codes",
  "disc.search_codes": "Search codes",
  "disc.add_codes": "Add codes",
  "disc.generate_codes": "Generate codes",
  "disc.add_codes_hint": "One code per line (or separated by commas).",
  "disc.export_codes": "Export codes",
  "disc.codes_added": "{n} codes added.",
  "disc.copy": "Copy code",
  "disc.copied": "Copied.",
  "disc.generate_hint": "Create up to 100,000 unique codes that share this discount's settings.",
  "disc.gen_count": "Number of codes",
  "disc.gen_prefix": "Prefix",
  "disc.gen_length": "Code length",
  "disc.gen_example": "Example",
  "dsum.all_products": "all products",
  "dsum.n_products": "{n} products",
  "dsum.n_collections": "{n} collections",
  "dsum.off": "{amount} off {what}",
  "dsum.off_each": "{amount} off each of {what}",
  "dsum.once_per_order": "Applies once per order",
  "dsum.off_order": "{amount} off entire order",
  "dsum.buy": "Buy {n} items",
  "dsum.spend": "Spend {amount}",
  "dsum.get_free": "get {n} items free",
  "dsum.get_off": "get {n} items at {pct}% off",
  "dsum.max_per_order": "Maximum {n} uses per order",
  "dsum.free_shipping_all": "Free shipping for all countries",
  "dsum.free_shipping_some": "Free shipping for {n} countries",
  "dsum.rates_under": "Applies to shipping rates up to {amount}",
  "dsum.min_amount": "Minimum purchase of {amount}",
  "dsum.min_quantity": "Minimum quantity of {n} items",
  "dsum.no_min": "No minimum purchase requirement",
  "dsum.all_customers": "For all customers",
  "dsum.n_segments": "For {n} customer segments",
  "dsum.n_customers": "For {n} customers",
  "dsum.limit": "Limit of {n} uses",
  "dsum.once_per_customer": "One use per customer",
  "dsum.combines": "Combines with {with}",
  "dsum.no_combine": "Can't combine with other discounts",
  "dsum.class.product": "product discounts",
  "dsum.class.order": "order discounts",
  "dsum.class.shipping": "shipping discounts",
  "dsum.active_from": "Active from {from}",
  "dsum.active_until": "Active from {from} until {to}",
  "picker.browse": "Browse",
  "picker.done": "Add ({n})",
  "picker.none": "Nothing found.",
  "picker.title.product": "Add products",
  "picker.title.collection": "Add collections",
  "picker.title.segment": "Add customer segments",
  "picker.title.customer": "Add customers",
  "picker.search_products": "Search products",
  "picker.search_collections": "Search collections",
  "picker.search_segments": "Search segments",
  "picker.search_customers": "Search customers",
} as const;

export default discountsEn;
